import {
  DynamicFormVariant,
  FORM_FIELD_TYPES,
  type FormDefinition,
  type FormDisplayComponent,
  type FormField,
  type FormSection,
  type FormStep,
} from '~/constants/formTypes'

import * as Yup from 'yup'
import { useOrgStore } from '~/stores/orgStore'

const companyInfoDisplayField: FormDisplayComponent = {
  name: 'CompanyInfoIntakeForm',
  label: 'CompanyInfoIntakeForm',
}

const companyName = 'companyName'
const companyNameField: FormField = {
  label: 'Company Name',
  name: companyName,
  componentType: FORM_FIELD_TYPES.inputCustom,
  rules: Yup.string(),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.companyName || ''
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    orgStore.updateOrgField(companyName, value)
  },
}

const companyWebsite = 'companyWebsite'
const companyWebsiteField: FormField = {
  label: 'Company Website URL',
  name: companyWebsite,
  componentType: FORM_FIELD_TYPES.inputCustom,
  rules: Yup.string().url(),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.companyWebsite || ''
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    orgStore.updateOrgField(companyWebsite, value)
  },
}

const linkedin = 'linkedin'
const companyLinkedInProfileField: FormField = {
  label: 'Company LinkedIn Profile URL',
  name: linkedin,
  componentType: FORM_FIELD_TYPES.inputCustom,
  rules: Yup.string().url(),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.linkedin || ''
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    orgStore.updateOrgField(linkedin, value)
  },
}

// TODO: Doesn't exist on object yet
// const companyReviewsField: FormField = {
//   label: 'Company Reviews URL',
//   name: 'companyReviews',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().url().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.reviewsUrl || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

const employeeCount = 'employeeCount'
const totalEmployeeCountField: FormField = {
  label: 'Total Employee Count',
  name: employeeCount,
  type: FORM_FIELD_TYPES.number,
  componentType: FORM_FIELD_TYPES.inputCustom,
  rules: Yup.number().min(0).max(1000000),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.employeeCount
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    const numVal = Number(value)
    !isNaN(numVal) && orgStore.updateOrgField(employeeCount, numVal)
  },
}

// const percentageOfTechnicalStaffField: FormField = {
//   label: 'Percentage of Technical Staff',
//   name: 'percentageOfTechnicalStaff',
//   type: FORM_FIELD_TYPES.number,
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.number().min(0).max(100).required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.percentageOfTechnicalStaff || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const companyDifferentiatorsField: FormField = {
//   label: 'Company Differentiators (comma separated)',
//   name: 'companyDifferentiators',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.companyDifferentiators || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const diversityEquityInclusionInitiativesField: FormField = {
//   label: 'Diversity, Equity & Inclusion Initiatives',
//   name: 'diversityEquityInclusionInitiatives',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.deiInitiatives || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const headquartersLocationField: FormField = {
//   label: 'Headquarters Location',
//   name: 'headquartersLocation',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.headquartersLocation || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const financialRunwayField: FormField = {
//   label: 'Financial Runway (Startups)',
//   name: 'financialRunway',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.financialRunway || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const applicantTrackingSystemField: FormField = {
//   label: 'Applicant Tracking System',
//   name: 'applicantTrackingSystem',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.applicantTrackingSystem || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const missionAndVisionStatementField: FormField = {
//   label: 'Mission and Vision Statement',
//   name: 'missionAndVisionStatement',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.missionAndVisionStatement || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const coreValuesAndCultureField: FormField = {
//   label: 'Core Values and Culture',
//   name: 'coreValuesAndCulture',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.coreValuesAndCulture || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const fairEvaluationPracticesField: FormField = {
//   label: 'Fair Evaluation Practices',
//   name: 'fairEvaluationPractices',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.fairEvalutationPractices || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const performanceReviewCycleField: FormField = {
//   label: 'Performance Review Cycle',
//   name: 'performanceReviewCycle',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.performanceReviewCycle || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const compensationReviewFrequencyField: FormField = {
//   label: 'Compensation Review Frequency',
//   name: 'compensationReviewFrequency',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.compensationReviewFrequency || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const workplaceDressCodeField: FormField = {
//   label: 'Workplace Dress Code',
//   name: 'workplaceDressCode',
//   componentType: FORM_FIELD_TYPES.inputCustom,
//   rules: Yup.string().required(),
//   value: computed(() => {
//     const userStore = useUserStore()
//     return userStore.user?.workplaceDressCode || ''
//   }),
//   onUpdate: (name: string, value: any) => {
//   },
// }

// const formFieldsAll: FormField[] = [
//   companyNameField,
//   companyWebsiteField,
//   companyLinkedInProfileField,
//   companyReviewsField,
//   totalEmployeeCountField,
//   percentageOfTechnicalStaffField,
//   companyDifferentiatorsField,
//   diversityEquityInclusionInitiativesField,
//   fairEvaluationPracticesField,
//   performanceReviewCycleField,
//   compensationReviewFrequencyField,
//   workplaceDressCodeField,
// ]

const intro = 'intro'
const introField: FormField = {
  label: 'Company Introduction',
  name: intro,
  componentType: FORM_FIELD_TYPES.textarea,
  rules: Yup.string(),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.intro || ''
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    orgStore.updateOrgField(intro, value)
  },
  placeholder:
    "We're Sproutly, a green-thumb-tech company on a quest to end plant neglect. We started in a garden shed in Ghent and are now a growing team of 50 plant-lovers across Europe, dedicated to making plant parenthood easy and fun for everyone.",
  helpText:
    "This is your elevator pitch! It's the first thing a candidate reads. A great intro gets them excited about your mission and helps them picture themselves as part of your story.",
}

const productDescription = 'productDescription'
const productDescriptionField: FormField = {
  label: 'Product Description',
  name: productDescription,
  componentType: FORM_FIELD_TYPES.textarea,
  rules: Yup.string(),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.productDescription || ''
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    orgStore.updateOrgField(productDescription, value)
  },
  placeholder:
    "Our core product is a mobile app, 'LeafLink', connected to a smart soil sensor. The app translates a plant's needs (water, light, nutrients) into quirky, actionable notifications, like 'Your fern is feeling a bit parched!' or 'This ficus fancies a sunnier spot.",
  helpText:
    "Top talent wants to build cool things. Clearly describe the product or service so they understand what they'll be creating, improving, or supporting. The more tangible, the better!",
}

const missionVision = 'missionVision'
const missionVisionField: FormField = {
  label: 'Mission & Vision',
  name: missionVision,
  componentType: FORM_FIELD_TYPES.textarea,
  rules: Yup.string(),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.missionVision || ''
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    orgStore.updateOrgField(missionVision, value)
  },
  placeholder:
    'Mission: To create a world where every plant feels understood. Vision: To have a Sproutly sensor in every pot, fostering a deeper connection between people and nature.',
  helpText:
    "Mission is why you exist today; Vision is what you're aiming for tomorrow. This isn't just fluffy stuff—it's the North Star that guides your team and attracts candidates who share your purpose.",
}

const companyCulture = 'companyCulture'
const companyCultureField: FormField = {
  candidateVisible: true,
  label: 'What sets us apart from competitors?',
  name: companyCulture,
  componentType: FORM_FIELD_TYPES.textarea,
  rules: Yup.string(),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.companyCulture || ''
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    orgStore.updateOrgField(companyCulture, value)
  },
  placeholder:
    "While competitors focus only on watering schedules, our secret sauce is our 'Plant Personality Engine'. We use machine learning to give each plant a unique communication style, turning plant care into an engaging, Tamagotchi-like experience.",
  helpText:
    'This is your unique selling proposition (USP). Smart candidates will ask this. Defining your edge helps us attract people who are passionate about your specific approach to solving a problem.',
}

const twitter = 'twitter'
const twitterField: FormField = {
  label: 'Twitter Profile URL',
  name: twitter,
  componentType: FORM_FIELD_TYPES.inputCustom,
  rules: Yup.string().url(),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.twitter || ''
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    orgStore.updateOrgField(twitter, value)
  },
}

const facebook = 'facebook'
const facebookField: FormField = {
  label: 'Facebook Profile URL',
  name: facebook,
  componentType: FORM_FIELD_TYPES.inputCustom,
  rules: Yup.string().url(),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.facebook || ''
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    orgStore.updateOrgField(facebook, value)
  },
}

const instagram = 'instagram'
const instagramField: FormField = {
  label: 'Instagram Profile URL',
  name: instagram,
  componentType: FORM_FIELD_TYPES.inputCustom,
  rules: Yup.string().url(),
  value: computed(() => {
    const orgStore = useOrgStore()
    return orgStore.selected?.instagram || ''
  }),
  onUpdate: (value: any) => {
    const orgStore = useOrgStore()
    orgStore.updateOrgField(instagram, value)
  },
}

const formFields0: FormField[] = [
  companyNameField,
  companyWebsiteField,
  totalEmployeeCountField,
]
const formFields1: FormField[] = [
  introField,
  productDescriptionField,
  missionVisionField,
  companyCultureField,
]
const formFields2: FormField[] = [
  companyLinkedInProfileField,
  twitterField,
  facebookField,
  instagramField,
]

const section0: FormSection = {
  id: 'section0',
  label: 'Basic Information',
  fields: formFields0,
}

export const companyInfoDisplaySection: FormSection = {
  id: 'section1',
  label: 'Company Info',
  fields: [],
  displayComponents: [companyInfoDisplayField],
}

const section1: FormSection = {
  id: 'section1',
  label: 'Company Description',
  fields: formFields1,
}

const section2: FormSection = {
  id: 'section2',
  label: 'Social Media',
  fields: formFields2,
}

const companyEditStep: FormStep = {
  id: 'companyEditStep',
  title: '',
  sections: [section0, section1, section2],
  variant: DynamicFormVariant.Grid,
}

export const companyInfoDisplayStep: FormStep = {
  id: 'step1',
  title: 'Company Info',
  sections: [companyInfoDisplaySection],
  variant: DynamicFormVariant.Grid,
}

export const companyInfoSchema: FormDefinition = {
  id: 'companyInfo',
  name: 'Company Info',
  steps: [companyInfoDisplayStep],
  variant: DynamicFormVariant.Vertical,
}

export const companyInfoEditModalSchema: FormDefinition = {
  id: 'companyInfoEditModal',
  name: 'Company Info',
  steps: [companyEditStep],
  variant: DynamicFormVariant.Vertical,
}
